"use client";

import { useState } from "react";
import { motion } from "motion/react";
import Image from "next/image";
import { AccordionItem } from "./AccordionItem";
import { faqs } from "../data";
import {
  slideUpVariants,
  slideFromLeftVariants,
  staggerContainerVariants,
} from "@/lib/animations";

export function FAQs() {
  const [openId, setOpenId] = useState<number | null>(null);

  const handleToggle = (id: number) =>
    setOpenId((prevId) => (prevId === id ? null : id));

  return (
    <section
      id="faqs"
      className="bg-white px-5 py-10 md:px-6 md:py-14 lg:px-10 lg:py-16 2xl:py-20"
    >
      <div className="mx-auto max-w-8xl">
        <motion.h2
          className="text-black-100 mb-5 text-center text-xl font-medium tracking-copy md:mb-10 md:text-4xl lg:mb-16 lg:text-4xl xl:text-[40px]"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={slideUpVariants}
        >
          Frequently Asked Questions
        </motion.h2>

        <div className="flex gap-5 md:items-start md:gap-10 lg:gap-12">
          <motion.div
            className="relative hidden md:block md:min-h-[798px] md:flex-1 md:basis-2/5 xl:min-h-96 2xl:min-h-0"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={slideFromLeftVariants}
          >
            <Image
              src="/assets/images/customer-care-rep.webp"
              alt="customer care representative on call"
              width={587}
              height={498}
              priority
              className="rounded-2xl"
            />

            <Image
              src="/assets/images/patterns/pattern-2.svg"
              alt="pattern"
              width={587}
              height={498}
              priority
              className="absolute -right-48 bottom-0 hidden h-full w-full lg:block"
            />
          </motion.div>

          <motion.div
            className="relative z-10 flex-1 rounded-2xl bg-grey-900 md:basis-3/5"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={staggerContainerVariants}
          >
            {faqs.map((faq, index) => (
              <motion.div
                key={faq.id}
                className={
                  index < faqs.length - 1 ? "border-b-[2px] border-white" : ""
                }
                variants={slideUpVariants}
              >
                <AccordionItem
                  faq={faq}
                  isOpen={openId === faq.id}
                  onToggle={() => handleToggle(faq.id)}
                />
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
